// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_RiJw3","markdown-html-wrap":"markdown-html-wrap_qo5zo"};